import React from 'react';
import './cuadro.css';

class Cuadro extends React.Component {

    render() {
        return  <div className={"pasos__cuadro pasos__cuadro--"+this.props.marca+(this.props.ultimo?" ultimo":"")}>
                    {
                        this.props.paso.orden<this.props.pasoActual.orden?(
                            <div className="pasado">
                                <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48 48">
                                    <path d="M12.5 25.5L20.7 33.7 35.2 14.4" stroke="#ffffff" strokeWidth="1" fill="none" fillRule="evenodd"/>
                                </svg>
                            </div>
                        ):(this.props.paso.orden>this.props.pasoActual.orden?(
                            <div className="futuro">
                                
                            </div>
                        ):(
                            <div className={"actual"+(this.props.paso.resultado==="Perdida"?" error":"")}>
                                
                            </div>
                        ))
                    }
                </div>
    }
}

export default Cuadro;